<script>
	import Media from '../molecules/Media.svelte';
	export let media;
</script>

<div>
	{#each media as elem}
		<Media media={elem} maxValue={-1} route="portefolio/{elem.idPortfolio}" />
	{/each}
</div>

<style>
	div {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
</style>
